import React, { useEffect, useState } from 'react';
import { ButtonToolbar, Col, Row } from 'react-bootstrap';
import Pagination, { Position } from './Pagination';
import Product, { IProduct } from './Product';
import SortDropdown, { Method, Order, sortByDiscount, sortByName, sortByPrice } from "./SortDropdown";
import PageSizeSelector from "./PageSizeSelector";

interface Props {
  hidePrices?: boolean,
  products: IProduct[],
  pagination?: Position,
  sort?: boolean,
}

const ProductGrid = (props: Props) => {
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(24);
  const [sliceFrom, sliceTo] = [(page-1)*pageSize, page*pageSize];
  const [firstPage, lastPage] = [1, Math.floor(props.products.length/pageSize)];
  const [sortMethod, setSortMethod] = useState<(Method)>(Method.Discount);
  const [sortOrder, setSortOrder] = useState<Order>(Order.Up);

  const sortBy = (Method.Discount === sortMethod) ? sortByDiscount : (Method.Name === sortMethod) ? sortByName : sortByPrice;

  // Reset to first page after page size, sort method, and sort order change.
  useEffect(() => {
    setPage(firstPage);
  }, [firstPage, pageSize, sortMethod, sortOrder]);

  // Reset sort order to up whenever the sort method changes.
  useEffect(() => {
    setSortOrder(Order.Up);
  }, [sortMethod]);

  // Scroll to the top of the page whenever the page number changes.
  useEffect(() => {
    window.scrollTo({behavior: "smooth", top: 0});
  }, [page]);

  return(
    <>
      {
        props.pagination || props.sort
        ? <Row>
            <Col>
              <ButtonToolbar className="d-flex flex-row justify-content-between mb-3" aria-label="Toolbar met opties voor productweergave">
              {
                props.pagination
                ? <PageSizeSelector
                    page={page}
                    size={pageSize}
                    setPage={setPage}
                    setSize={setPageSize} />
                : <></>
              }
              {
                props.sort
                ? <SortDropdown
                    method={sortMethod}
                    order={sortOrder}
                    setMethod={setSortMethod}
                    setOrder={setSortOrder} />
                : <></>
              }
              </ButtonToolbar>
            </Col>
          </Row>
        : <></>
      }
      {
        Position.Both === props.pagination || Position.Top === props.pagination
        ? <Row>
            <Col>
              <Pagination page={page} setPage={setPage} firstPage={firstPage} lastPage={lastPage} />
            </Col>
          </Row>
        : <></>
      }
        <Row className="products row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
          {
            props.products
              .sort((a: IProduct, b: IProduct) => (sortOrder === Order.Down ? -1 : 1) * sortBy(a, b))
              .slice(sliceFrom, sliceTo)
              .map((product, i) =>
                <Product key={i} product={product} hidePrice={props.hidePrices} />
            )
          }
        </Row>
      {
        Position.Both === props.pagination || Position.Bottom === props.pagination
        ? <Row>
            <Col>
              <Pagination page={page} setPage={setPage} firstPage={firstPage} lastPage={lastPage} />
            </Col>
          </Row>
        : <></>
      }
    </>
  );
};

export default ProductGrid;